import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Box, Typography, CircularProgress } from "@mui/material";

export default function AESSORedirect() {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { ssoLogin } = useAuth();

  useEffect(() => {
    const handleSSO = async () => {
      const code = searchParams.get("code");
      if (!code) {
        setError("Missing authorization code. Cannot complete SSO.");
        return;
      }

      try {
        await ssoLogin(code);
        navigate("/"); // Successfully logged in, go to home
      } catch (err) {
        console.error("SSO Error:", err);
        if (err.response?.status === 403 && err.response?.data?.detail === "Account pending admin approval") {
          setError("Your account has been created and is pending Admin approval. Please contact your system administrator.");
        } else {
          setError("Authentication failed during SSO exchange.");
        }
      }
    };

    handleSSO();
  }, [searchParams, navigate, ssoLogin]);

  return (
    <Box sx={{
      display: "flex", height: "100vh", width: "100%",
      alignItems: "center", justifyContent: "center", flexDirection: "column"
    }}>
      {error ? (
        <Typography color="error" variant="h6">{error}</Typography>
      ) : (
        <>
          <CircularProgress size={50} sx={{ mb: 4, color: "#F26522" }} />
          <Typography variant="h6">Completing AutomationEdge SSO Login...</Typography>
        </>
      )}
    </Box>
  );
}
